import React from 'react';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { TimelineScale } from './types';
import { TimelineScaleSelect } from './TimelineScaleSelect';

export const ScheduleTimelineControls: React.FC<{
    onScaleChange: (scale: TimelineScale) => void;
    onShowCompletedTasksChange: (show: boolean) => void;
    showCompletedTasks: boolean;
}> = ({ onScaleChange, onShowCompletedTasksChange, showCompletedTasks }) => {
    const { t } = useTranslation();
    return (
        <div className="timeline-zoom-controls schedule-mode-controls">
            <div className="timeline-zoom-controls-main">
                <span className="timeline-active-period-label">{t('dailyPlanner.schedule')}</span>
                <TimelineScaleSelect value="schedule" onOpenSchedule={() => undefined}
                    onScaleChange={onScaleChange} />
                <button type="button" className="timeline-completed-toggle"
                    onClick={() => onShowCompletedTasksChange(!showCompletedTasks)}
                    aria-pressed={showCompletedTasks}
                    aria-label={t('dailyPlanner.showCompletedTasks')}
                    title={t('dailyPlanner.showCompletedTasks')}>
                    <FontAwesomeIcon icon={showCompletedTasks ? faEye : faEyeSlash} />
                </button>
            </div>
        </div>
    );
};
